export default __webpack_public_path__ + "static/media/show-imgae.d67f087f.png";